// Repaints the synced Neo body with the live aico document when it differs, any failure keeps the synced paint
// Load after content-builder-neo.js
(function (w, d) {
  'use strict';

  var TIMEOUT_MS = 2500;

  function boot() {
    var mount = d.getElementById('aico-content');
    if (!mount || !w.NewsNeo || typeof w.NewsNeo.render !== 'function') return;

    var url = mount.getAttribute('data-aico-live-url');
    if (!url) return;

    var settled = false;
    var controller = ('AbortController' in w) ? new w.AbortController() : null;
    var timer = w.setTimeout(function () {
      if (settled) return;
      settled = true;
      if (controller) controller.abort();
    }, TIMEOUT_MS);

    function done() {
      settled = true;
      w.clearTimeout(timer);
    }

    function sameAsPainted(fresh) {
      var el = d.getElementById('aico-page-data');
      if (!el) return false;
      try {
        var painted = JSON.parse(el.textContent || el.innerText || '{}');
        return JSON.stringify(painted.contentBuilderNeoJson) === JSON.stringify(fresh);
      } catch (e) {
        return false;
      }
    }

    try {
      w.fetch(url, {
        credentials: 'omit',
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (settled) return;
          done();
          if (!data || !data.contentBuilderNeoJson) return;
          if (sameAsPainted(data.contentBuilderNeoJson)) return;
          mount.innerHTML = w.NewsNeo.render(data);
          if (typeof w.NewsNeo.hydrate === 'function') w.NewsNeo.hydrate(mount);
          mount.setAttribute('data-aico-neo-source', 'live');
        })
        .catch(function () {
          done();
          // the synced paint stands
        });
    } catch (e) {
      done();
    }
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window, document);
